module.exports = __webpack_public_path__ + "static/media/temp_w_domu_grzanie_4.0aca4826.svg";